/* Geloria, landing « sur le modèle Geeli House » (2026-10-06), sections geloria-lp2-*.
   Trois comportements, rien d'autre : les flèches et la barre de progression des carrousels ([data-gl2-car]),
   les puces qui filtrent les avis ([data-gl2-filtres]), l'agrandissement d'une photo ([data-gl2-zoom]).
   Le fichier est appelé par chaque section : il ne s'installe qu'une fois, puis relance seulement init()
   (utile dans l'éditeur de thème, qui recharge une section à la fois). */
(function () {
  if (window.__gl2) { window.__gl2.init(); return; }

  function visibles(piste) {
    return Array.prototype.filter.call(piste.children, function (c) { return !c.hidden; });
  }

  function pas(piste) {
    var c = visibles(piste)[0];
    if (!c) return piste.clientWidth;
    var s = window.getComputedStyle(piste);
    return c.getBoundingClientRect().width + (parseFloat(s.columnGap) || 0);
  }

  function maj(car) {
    if (!car) return;
    var piste = car.querySelector('[data-gl2-piste]');
    if (!piste) return;
    var max = piste.scrollWidth - piste.clientWidth;
    var x = Math.abs(piste.scrollLeft);
    var barre = car.querySelector('[data-gl2-prog]');
    if (barre) {
      var part = piste.scrollWidth ? Math.min(1, piste.clientWidth / piste.scrollWidth) : 1;
      barre.style.width = Math.max(part * 100, 10) + '%';
      barre.style.left = (max > 0 ? (x / max) * (100 - Math.max(part * 100, 10)) : 0) + '%';
    }
    car.querySelectorAll('[data-gl2-sens]').forEach(function (b) {
      b.disabled = parseInt(b.getAttribute('data-gl2-sens'), 10) < 0 ? x <= 2 : x >= max - 2;
    });
  }

  function init() {
    document.querySelectorAll('[data-gl2-car]:not([data-gl2-ok])').forEach(function (car) {
      car.setAttribute('data-gl2-ok', '');
      var piste = car.querySelector('[data-gl2-piste]');
      if (!piste) return;
      car.querySelectorAll('[data-gl2-sens]').forEach(function (b) {
        b.addEventListener('click', function () {
          piste.scrollBy({ left: pas(piste) * parseInt(b.getAttribute('data-gl2-sens'), 10), behavior: 'smooth' });
        });
      });
      var attente = false;
      piste.addEventListener('scroll', function () {
        if (attente) return;
        attente = true;
        window.requestAnimationFrame(function () { attente = false; maj(car); });
      }, { passive: true });
      window.addEventListener('resize', function () { maj(car); });
      maj(car);
    });

    document.querySelectorAll('[data-gl2-filtres]:not([data-gl2-ok])').forEach(function (f) {
      f.setAttribute('data-gl2-ok', '');
      var sec = f.closest('[data-gl2-avis]');
      if (!sec) return;
      var car = sec.querySelector('[data-gl2-car]');
      var piste = sec.querySelector('[data-gl2-piste]');
      function appliquer(theme) {
        f.querySelectorAll('[data-gl2-theme]').forEach(function (p) {
          p.setAttribute('aria-pressed', p.getAttribute('data-gl2-theme') === theme ? 'true' : 'false');
        });
        piste.querySelectorAll('[data-gl2-carte]').forEach(function (c) {
          c.hidden = (c.getAttribute('data-gl2-themes') || '').split('|').indexOf(theme) < 0;
        });
        piste.scrollLeft = 0;
        maj(car);
      }
      f.querySelectorAll('[data-gl2-theme]').forEach(function (p) {
        p.addEventListener('click', function () { appliquer(p.getAttribute('data-gl2-theme')); });
      });
      var actif = f.querySelector('[aria-pressed="true"]');
      if (actif) appliquer(actif.getAttribute('data-gl2-theme'));
    });
  }

  var boite;
  document.addEventListener('click', function (e) {
    var z = e.target && e.target.closest ? e.target.closest('[data-gl2-zoom]') : null;
    if (!z) return;
    e.preventDefault();
    if (!boite) {
      boite = document.createElement('dialog');
      boite.className = 'gl2-lb';
      boite.innerHTML = '<button type="button" class="gl2-lb__x" aria-label="Fermer">&times;</button><img alt="">';
      document.body.appendChild(boite);
      boite.addEventListener('click', function () { boite.close(); });
    }
    var img = boite.querySelector('img');
    img.src = z.getAttribute('data-gl2-zoom');
    img.alt = z.getAttribute('data-gl2-alt') || '';
    if (typeof boite.showModal === 'function') { boite.showModal(); } else { window.open(img.src, '_blank'); }
  });

  window.__gl2 = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
